import './utils/canvasCompat.js';
import './style.css';
import { config } from './config.js';
import { Game } from './core/Game.js';
import { Settings } from './core/Settings.js';
import { khartoumLevel } from './world/levels/khartoum.js';
import { UI } from './ui/UI.js';

document.title = `${config.meta.title} — ${config.meta.stageTitle}, Khartoum`;

const canvas = document.getElementById('game-canvas');
const settings = new Settings();
const ui = new UI({ meta: config.meta, settings });

let game = null;

ui.onPrimary = () => {
  if (!game) return;
  if (game.state === 'ready') game.start();
  else if (game.state === 'paused') game.resume();
  else if (game.state === 'gameover') game.restart();
};

async function boot() {
  try {
    game = new Game({ canvas, level: khartoumLevel, config, settings });
    game.onStateChange = (state) =>
      ui.setState(state, {
        gameOverReason: game.gameOverReason,
        deathCause: game.deathCause,
        score: game.money,
      });

    await game.init((progress, label) => ui.setLoading(progress, label));
    game.startLoop();

    // Handy for poking at the simulation from the console while developing.
    if (import.meta.env.DEV) {
      window.__game = game;
      window.__ui = ui;
    }
  } catch (error) {
    console.error(error);
    ui.showError(error);
  }
}

boot().catch((error) => {
  console.error(error);
  ui.showError(error);
});
